import React from 'react';

export function cloneProgramTableHoldPayload<T>(live: T): T {
  const src = live as {
    tableRows?: unknown[];
    programCellsByAnnualKey?: Record<string, Record<string, unknown>>;
    scheduleSlotAnnualCellKeys?: string[];
  };
  const next: Record<string, unknown> = { ...(live as Record<string, unknown>) };
  if (Array.isArray(src.tableRows)) {
    next.tableRows = src.tableRows.map((row) =>
      row && typeof row === 'object' ? { ...(row as Record<string, unknown>) } : row
    );
  }
  if (src.programCellsByAnnualKey && typeof src.programCellsByAnnualKey === 'object') {
    next.programCellsByAnnualKey = Object.fromEntries(
      Object.entries(src.programCellsByAnnualKey).map(([key, cell]) => {
        const bg = cell?.bg_color_by_field;
        return [
          key,
          {
            ...cell,
            bg_color_by_field:
              bg && typeof bg === 'object' ? { ...(bg as Record<string, unknown>) } : {},
          },
        ];
      })
    );
  }
  if (Array.isArray(src.scheduleSlotAnnualCellKeys)) {
    next.scheduleSlotAnnualCellKeys = [...src.scheduleSlotAnnualCellKeys];
  }
  return next as T;
}

/**
 * 프로그램 표 저장이 끝날 때까지 지금 화면의 표 데이터를 고정한다.
 * 저장 중 워크스페이스 오버레이가 먼저 걷히거나 예전 LS가 끼어들어도
 * 수정 중인 모습이 그대로 보이게 한다.
 */
export function useProgramPostSaveDisplayHold<T>(live: T): {
  display: T;
  holding: boolean;
  beginHold: (value: T) => void;
  endHold: () => void;
} {
  const [snapshot, setSnapshot] = React.useState<T | null>(null);

  const beginHold = React.useCallback((value: T) => {
    setSnapshot(value);
  }, []);

  const endHold = React.useCallback(() => {
    setSnapshot(null);
  }, []);

  const holding = snapshot != null;
  return {
    display: holding ? snapshot : live,
    holding,
    beginHold,
    endHold,
  };
}
